import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionModelService } from '../../shared/services/index';
import { ApplicationSubType, Inspection } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit.component.html',
    standalone: false
})
export class InspectionModelEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  errorMessage: string;
  inspectionId: string;
  returnUrl: string = null;
  statusList: number[];
  public processing = false;

  constructor(
    private inspectionModelService: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];

      if (id == null) this.goToBack();
      this.returnUrl = params['returnUrl'];
      this.inspectionId = id;
      this.initData();
    });
  }

  saveInspection(inspection: Inspection): void {
    this.inspectionModelService
      .updateInspectionProperties(inspection.id, {
        name: inspection.name,
        description: inspection.description,
        status: inspection.status,
        coverImage: inspection.coverImage,
        category: inspection.category
      })
      .subscribe((el) => {
        this.inspection = el;
        if (this.inspection.applicationSubType == ApplicationSubType.ParentInstallation) {
          return this.router.navigate([
            this.templatesRoute,
            inspection.id,
            'view',
            `${this.templatesRoute}/${inspection.id}/templates`
          ]);
        }
        this.router.navigate([this.templatesRoute, inspection.id, 'view', `${this.templatesRoute}/${inspection.id}`]);
      });
  }

  cancel(): void {
    this.goToBack();
  }

  initData(): void {
    this.inspectionModelService.getModel(this.inspectionId).subscribe((el) => {
      this.inspection = el;
      this.cdf.detectChanges();
    });
    this.statusList = this.inspectionModelService.getStatusList();
  }
}
